import { h } from "preact";
export const Wedge = () => {
  return (
    <svg class="icon-wedge wedge-left small-hide medium-hide" viewBox="0 0 20 40" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="Batch-1-Revisions" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Home-Copy" transform="translate(-100.000000, -1542.000000)" fill="#ffffff">
              <g id="Image-Left" transform="translate(100.000000, 1372.000000)">
                  <path d="M0,170.001 L19.999981,190.000778 L0,210.001 L0,170.001 Z" id="side-wedge-right"></path>
              </g>
          </g>
      </g>
    </svg>
  );
};